/*
  * Broadcast Theme
  *
  * Use this file to add custom Javascript to Broadcast.  Keeping your custom
  * Javascript in this fill will make it easier to update Broadcast. In order
  * to use this file you will need to open layout/theme.liquid and uncomment
  * the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', function() {
    
    // let checkRecharge = setInterval(function() {
    //   if(document.querySelector('.rc_container')) {
    //     console.log("Recharge Loaded")
    //     clearInterval(checkRecharge);

    //     /* Begin Smartrr Comment
    //     ** buildRecharge();
    //     ** End Smartrr Comment */
    //    /* Begin Smartrr Code */
    //    document.querySelectorAll('.rc_container').forEach(function ($e) {
    //     $e.remove();
    //   });
    //   /* End Smartrr Code */
    //   } else {
    //     console.log("Recharge Not Loaded");
    //   }
    // }, 100);


    function buildRecharge() {
      let currentWidget = ReChargeWidget.getWidgets()[0];
      console.log(currentWidget);
      let selectors = ReChargeWidget.getWidgets()[0].selectors;
      console.log(selectors);
      console.log(document.querySelector(selectors.optionOnetime));
      const rechargeButton = document.querySelector(selectors.optionSubsave);
      const rechargeButtonLabel = rechargeButton.querySelector('.rc_widget__option__label')
      const onetimeButton = document.querySelector(selectors.optionOnetime);
      const onetimeButtonLabel = onetimeButton.querySelector('.rc_widget__option__label')

      // reorganizing the recharge button label 
      const container = document.createElement('div');
      rechargeButtonLabel.appendChild(container);
      container.appendChild(document.querySelector(selectors.optionSubsave).querySelector('.rc-option__text'));
      container.appendChild(document.querySelector(selectors.optionSubsave).querySelector('.rc-option__discount'));

      const priceContainer = document.createElement('div');
      priceContainer.classList.add('price-container');
      rechargeButtonLabel.appendChild(priceContainer);
      const discountedPrice = document.createElement('s');
      discountedPrice.classList.add('rc_widget__price--discounted');
      discountedPrice.innerText = document.querySelector(selectors.optionOnetime).querySelector('.rc-option__price').innerText;
      priceContainer.appendChild(discountedPrice);

      priceContainer.appendChild(document.querySelector(selectors.optionSubsave).querySelector('.rc-option__price'));

      // adding a new input button to the recharge button
      const inputButton = document.createElement('div');
      const inputButtonInner = document.createElement('div');
      inputButton.classList.add('rc-option__input');
      inputButtonInner.classList.add('rc-option__input__inner');
      inputButton.appendChild(inputButtonInner);
      document.querySelector(selectors.optionOnetime).appendChild(inputButton);


      const inputButtonSub = document.createElement('div');
      const inputButtonSubInner = document.createElement('div');
      inputButtonSub.classList.add('rc-option__input');
      inputButtonSubInner.classList.add('rc-option__input__inner');
      inputButtonSub.appendChild(inputButtonSubInner);
      document.querySelector(selectors.optionSubsave).appendChild(inputButtonSub);
      const sellingPlanGroup = currentWidget.productData.selling_plan_groups[0].selling_plan_group_id;
      const sellingPlans = currentWidget.productData.selling_plan_groups[0].selling_plans.map(plan => {
        return plan;
      });
      document.querySelector(selectors.plansDropdown).remove();

      // adding a new frequency selector to the recharge widget
      const frequencySelector = document.createElement('div');
      frequencySelector.classList.add('rc-option__subsave-container');

      document.querySelector('[data-radio-group-options]').appendChild(frequencySelector);
      frequencySelector.appendChild(document.querySelector(selectors.optionSubsave));

      const frequencySelectorInner = document.createElement('div');
      frequencySelectorInner.classList.add('rc-option__frequency-selector');
      frequencySelector.appendChild(frequencySelectorInner);

      const frequencySelectorInfo = document.createElement('div');
      frequencySelectorInfo.classList.add('rc-option__frequency-selector__info');
      frequencySelectorInner.appendChild(frequencySelectorInfo);
      frequencySelectorInfo.appendChild(document.querySelector('.rc-selling-plans'));
      document.querySelector('.rc-selling-plans').innerHTML = 'Delivery Every:';
      frequencySelectorInfo.appendChild(document.querySelector('.rc_popup'))

      const frequencySelectorOptions = document.createElement('div');
      frequencySelectorOptions.classList.add('rc-option__frequency-selector__options');
      frequencySelectorInner.appendChild(frequencySelectorOptions);


      let subOptionsActive = false;

      onetimeButton.addEventListener('click', function() {
        document.querySelectorAll('.input-radio').forEach(radio => {
          radio.remove();
        })
        subOptionsActive = false;
      });

      rechargeButton.addEventListener('click', function() {
        if(!subOptionsActive) {
          sellingPlans.forEach((plan, index) => {
            const productId = currentWidget.productId;
            let frequencySelectorOption = document.createElement('div');
            frequencySelectorOption.classList.add('input-radio');
    
            let frequencySelectorOptionInput = document.createElement('input');
            frequencySelectorOptionInput.classList.add('input-radio__input');
            frequencySelectorOptionInput.setAttribute('type', 'radio');
            frequencySelectorOptionInput.setAttribute('name', 'selling_plan');
            if (index === 0) {
              frequencySelectorOptionInput.setAttribute('checked', 'checked');
            }
            frequencySelectorOptionInput.setAttribute('id', `selling_plan_${productId}_${index}`);
            frequencySelectorOptionInput.setAttribute('value', plan.selling_plan_id);
            frequencySelectorOption.appendChild(frequencySelectorOptionInput);
    
    
            let frequencySelectorOptionLabel = document.createElement('label');
            frequencySelectorOptionLabel.classList.add('input-radio__label');
            frequencySelectorOptionLabel.setAttribute('for', `selling_plan_${productId}_${index}`);
            frequencySelectorOptionLabel.innerHTML = plan.selling_plan_name.replace('every', '');
            frequencySelectorOption.appendChild(frequencySelectorOptionLabel);
    
            frequencySelectorOptions.appendChild(frequencySelectorOption);
          });
        }
        subOptionsActive = true;
      });
    }
  });
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
